import { ListCache } from "../ListCache";
import { PbPageTemplateWithContent } from "~/types";

export const pageTemplateCache = new ListCache<PbPageTemplateWithContent>();
